export async function getIconStyles(): Promise<string> {
    // @ts-ignore
    return import('./lazy/styles/icons').then(module => {
        return module.getIconStyles();
    });
}

export function registerLazyComponent(tagName: string, resolve: () => Promise<unknown>): void {
    const LAZY_LOADING_CLASS = 'nxt-lazy-loading';
    const LAZY_PLACEHOLDER_SLOT = '__nxt-lazy-placeholder';

    function showLazyPlaceholder(element: HTMLElement): HTMLElement {
        element.classList.add(LAZY_LOADING_CLASS);
        const placeholder = document.createElement('nxt-loading-indicator');
        placeholder.classList.add('nxt-lazy-placeholder');
        // Use a slot name that no component template defines, so it never gets
        // picked up as (default) slotted content once the component upgrades.
        placeholder.setAttribute('slot', LAZY_PLACEHOLDER_SLOT);
        element.appendChild(placeholder);
        return placeholder;
    }

    function removeLazyPlaceholder(element: HTMLElement, placeholder: HTMLElement): void {
        placeholder.remove();
        element.classList.remove(LAZY_LOADING_CLASS);
    }

    const bootstrap = () => {
        const elements = Array.from(document.querySelectorAll<HTMLElement>(tagName));
        if (elements.length === 0) {
            return;
        }
        const placeholders = elements.map((element) => [element, showLazyPlaceholder(element)] as const);
        const cleanup = () => placeholders.forEach(([element, placeholder]) => removeLazyPlaceholder(element, placeholder));
        resolve()
            .then(() => customElements.whenDefined(tagName))
            .then(cleanup, cleanup);
    };
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', bootstrap);
    } else {
        bootstrap();
    }
}
